import React from 'react'

import { IconDirections } from '@tabler/icons-react'
import styled, { keyframes } from 'styled-components'

const Message = styled.span`
  ${({ theme }) => theme.font.label02}
  width: 90%;
  max-width: 600px;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const Title = styled.span`
  text-align: center;
  margin-bottom: 1rem;
`

const flip = keyframes`
  0%, 40%, 100% {
    transform: rotateY(0deg);
  }
  50%, 90% {
    transform: rotateY(180deg);
  }
`

const Icon = styled.div`
  display: inline-block;
  animation: ${flip} 4s infinite;
  transform-origin: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5rem;
`

type CorePageMessageProps = {
  message: string
  children?: React.ReactNode
}

export const CorePageMessage = ({
  message,
  children,
}: CorePageMessageProps) => {
  return (
    <Message>
      <Icon>
        <IconDirections size={34} stroke={1.5} />
      </Icon>
      <Title>{message}</Title>
      {children}
    </Message>
  )
}
